module.exports = "/_next/static/images/2d7e28cdf0dbb93b7a034eda26883094-graph.svg.webp";